import React from "react";

import Applet from "../../Applet";
import ETLGoogleConfigurationDetailTableView from "../../../../components/Google/ETLGoogleConfigurationDetailTableView";
class ETLGoogleConfigurationDetailTableViewApplet extends Applet {

    render() {
        return <ETLGoogleConfigurationDetailTableView applet={this}
                                 pageSize={this.state.PageSize}
                                 placement={this.state.Placement}
                                 columns={this.state.Columns}
                                 title="Google Drive Contents"
                                 enterpriseComponent={this.getEnterpriseComponent()}
                                 sort={this.state.Sort}
                                 menu={this.state.Menu}
                                 rowHeight={this.state.RowHeight}
                                 simpleSearch={this.state.SimpleSearch}
                                 expansionDepth={this.state.ExpansionDepth}
                               // enableSort={true}
                               // enableSearch={true}

        />;
    }

    state = {
        Name: "ETLGoogleConfigurationDetailTableViewApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 60,
        ExpansionDepth: 1,
        PageSize: {
            "default": 10,
            "xs": 3,
            "sm": 3,
            "md": 10,
            "lg": 20,
            "lx": 20,
        },
        Placement: {
            "xl": [
                {
                    id: "Size",
                },
                {
                    id: "MimeType",
                },
                {
                    id: "CreatedTime",
                },
                {
                    id: "ModifiedTime",
                },
            ]
        },
        Columns: [
            {
                id: "Leader",
                width: 400,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Content",
            },
            {
                id: "Size",
                width: 100,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Size",
            },
            {
                id: "MimeType",
                width: 400,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Type",
            },
            {
                id: "CreatedTime",
                width: 240,
                cellRenderer: "Local Datetime Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Date Created",
            },
            {
                id: "ModifiedTime",
                width: 240,
                cellRenderer: "Local Datetime Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Date Modified",
            }
        ],
        Sort: []
    }
}

export default ETLGoogleConfigurationDetailTableViewApplet;
